import { useEffect, useReducer, useRef } from 'react';

type Callback = () => void;
type Trigger = () => void;

const COUNTER_MAX = 2 ** 32 - 1;

export const useDebounce = (callback: Callback, delay: number): Trigger => {
  const [[counter, isInitialEffect], increment] = useReducer(
    ([counter]) => [(counter + 1) % COUNTER_MAX, false],
    [0, true]
  );
  const callbackRef = useRef<Callback>();
  callbackRef.current = callback;

  useEffect(() => {
    if (isInitialEffect) return;

    const handle = setTimeout(() => callbackRef.current?.(), delay);
    return () => clearTimeout(handle);
  }, [counter, isInitialEffect, delay]);

  return increment;
};
